import React, { useMemo } from 'react';
import { node } from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import CustomDragLayer from './custom-drag-layer';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const ResponsiveDndProvider = ({ children }) => {
  const backend = useMemo(() => {
    if (isMobile()) {
      return TouchBackend;
    }

    return HTML5Backend;
  }, []);

  const options = useMemo(() => {
    if (isMobile()) {
      return {
        enableTouchEvents: true,
        enableMouseEvents: true,
      };
    }
    return {
      enableMouseEvents: true,
    };
  }, []);

  return (
    <DndProvider backend={backend} options={options}>
      {children}
      {backend === TouchBackend && <CustomDragLayer />}
    </DndProvider>
  );
};

ResponsiveDndProvider.propTypes = {
  children: node.isRequired,
};

export default ResponsiveDndProvider;
